import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Trips" hint="rr-backend Trip with replay link to gps-backend." /> }
